export const getEnvDefault = (runtimeKey: string, viteKey: string): string =>
  (typeof window !== 'undefined' && (window as Window & { _env_?: Record<string, string> })._env_?.[runtimeKey]) ||
  import.meta.env[viteKey as keyof ImportMetaEnv] ||
  '';
